import * as React from 'react';
import type { ReactNode } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';

export interface InfiniteScrollProps {
    hasError: boolean;
    loading: boolean;
    hasMoreData: boolean;
    loadMoreData: VoidFunction;
    renderData: () => ReactNode;
    topThreshold?: number;
}

export const InfiniteScroll: React.FC<React.PropsWithChildren<InfiniteScrollProps>> = props => {
    const { loading, hasError, hasMoreData, topThreshold = 400, loadMoreData, renderData, children } = props;

    const [infiniteScrollTriggerRef] = useInfiniteScroll({
        loading,
        hasNextPage: hasMoreData,
        onLoadMore: loadMoreData,
        disabled: hasError,
        rootMargin: `0px 0px ${topThreshold}px`,
    });

    return (
        <div>
            {renderData()}
            <div ref={infiniteScrollTriggerRef}>{children}</div>
        </div>
    );
};
